<template>
  <AppHeaderDropdown right>
    <template slot="header">
      <img :src="$auth.user().photo_url" alt="Avatar" class="img-avatar"/>
      {{ $auth.user().name }}
    </template>
    <template slot="dropdown">
      <b-dropdown-header tag="div" class="text-center">
        <strong>Account</strong>
      </b-dropdown-header>
      <b-dropdown-item to="messages">
        <font-awesome-icon icon="envelope"></font-awesome-icon>
        Messages
        <b-badge variant="danger">{{ this.$store.state.messagesCount }}</b-badge>
      </b-dropdown-item>
      <b-dropdown-header tag="div" class="text-center">
        <strong>Settings</strong>
      </b-dropdown-header>
      <b-dropdown-item :to="'/users/' + $auth.user().id">
        <font-awesome-icon icon="user"></font-awesome-icon>
        Profile
      </b-dropdown-item>
      <b-dropdown-item @click="logout">
        <font-awesome-icon icon="lock"></font-awesome-icon>
        Logout
      </b-dropdown-item>
    </template>
  </AppHeaderDropdown>
</template>

<script>
import { HeaderDropdown as AppHeaderDropdown } from '@coreui/vue';

export default {
  name: 'DefaultHeaderDropdownAccnt',
  components: {
    AppHeaderDropdown
  },
  methods: {

    logout () {
      this.$store.dispatch('RESET_STATE');
      this.$auth.logout();
      window.location.reload();
    }
  }
};
</script>

<style>
  .dropdown-item svg {
    display: inline-block;
    width: 20px;
    margin-right: 10px;
    margin-left: -10px;
    color: rgba(0, 0, 0, 0.15);
    text-align: center;
  }
</style>
